module.exports = __webpack_public_path__ + "static/media/heatbliss-5.5ec7035a.jpg";